var preset_default = { theme: { extend: {
	boxShadow: { "inset-blue": "inset 3px 0 0px 0px #6676FE" },
	fontSize: {
		"header-1": "1.5rem",
		"header-2": "1.25rem",
		"header-3": "1rem",
		label: "0.875rem",
		base: "0.875rem"
	},
	fontFamily: {
		sans: [
			"Inter",
			"Helvetica",
			"Arial",
			"sans-serif"
		],
		body: [
			"Inter",
			"Helvetica",
			"Arial",
			"sans-serif"
		],
		mono: [
			"JetBrains Mono",
			"Menlo",
			"Monaco",
			"Consolas",
			"monospace"
		],
		menlo: [
			"menlo",
			"Helvetica",
			"Arial",
			"sans-serif"
		]
	},
	spacing: {
		1: "0.25rem",
		2: "0.5rem",
		3: "0.75rem",
		4: "1rem",
		5: "1.25rem",
		6: "1.5rem",
		7: "2rem",
		8: "2.5rem",
		9: "3rem",
		10: "4rem"
	},
	colors: {
		mxmz: {
			brand: {
				dark: "#0F1741",
				light: "#E7E9FB",
				gray: "#D1D5DC",
				white: "#F9FAFB"
			},
			blue: {
				50: "#E7E9FB",
				100: "#D4D9FC",
				200: "#AFB8FD",
				300: "#8B97FD",
				400: "#6676FE",
				500: "#4155FF",
				600: "#3545D0",
				700: "#2836A0",
				800: "#1C2671",
				900: "#0F1741",
				950: "#090F2A"
			}
		},
		semantic: {
			background: {
				dark: "#151621",
				light: "#C6C7CB"
			},
			surface: {
				dark: "#232432",
				light: "#E7E8EA"
			},
			card: {
				dark: "#323342",
				light: "#F9FAFB"
			},
			modal: {
				dark: "#484957",
				light: "#F9FAFB"
			},
			overlay: "rgba(9, 15, 42, 0.5)",
			border: {
				dark: "rgba(249, 250, 251, 0.15)",
				light: "#AAAAB1"
			},
			foreground: {
				dark: "#F9FAFB",
				light: "#151621",
				secondary: {
					dark: "#777883",
					light: "#90919A"
				}
			},
			button: {
				foreground: "#F9FAFB",
				muted: "#777883"
			},
			muted: {
				dark: "#90919A",
				light: "#AAAAB1"
			}
		},
		gray: {
			50: "#F9FAFB",
			100: "#E7E8EA",
			200: "#C6C7CB",
			300: "#AAAAB1",
			400: "#90919A",
			500: "#777883",
			600: "#5F606C",
			700: "#484957",
			800: "#323342",
			900: "#232432",
			950: "#151621"
		},
		primary: "#4155FF",
		"primary-hover": "#576AFF",
		"primary-safe": "#4360EB",
		"primary-light": "#6676FE",
		"primary-light-hover": "#576AFF",
		"primary-light-active": "#3545D0",
		secondary: "#5B5D70",
		"secondary-hover": "#6E7081",
		white: "#F9FAFB",
		"white-hover": "#C6C7CB",
		"white-active": "#AAAAB1",
		"white-safe": "#EBEBEB",
		"black-safe": "#101010",
		success: "#00D492",
		"success-hover": "#00E09B",
		danger: "#E11D48",
		"danger-hover": "#E4375E",
		live: "#F43F5E",
		"live-hover": "#F45572",
		warning: "#F59E0B",
		"warning-hover": "#F5A929",
		"default-surface": "#151621",
		"elevated-0": "#1B1C29",
		"elevated-1": "#232432",
		"elevated-2": "#323342",
		modal: "#F9FAFB",
		"input-dark": "#191A26",
		"gr-gray-dark": "#323342",
		"gr-gray-light": "#5F606C",
		"gr-red-dark": "#A50036",
		"gr-red-light": "#ED0040",
		purple: "#9C79FF",
		"purple-dark": "#809C79FF",
		"purple-dark-alt": "#594890"
	}
} } };
export { preset_default as t };

//# sourceMappingURL=preset-B9qMHp0b.js.map